import { render, staticRenderFns } from "./CanopyAndWelcome.vue?vue&type=template&id=0c467c3b&scoped=true&"
import script from "./CanopyAndWelcome.vue?vue&type=script&lang=js&"
export * from "./CanopyAndWelcome.vue?vue&type=script&lang=js&"
import style0 from "./CanopyAndWelcome.vue?vue&type=style&index=0&id=0c467c3b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c467c3b",
  null
  
)

export default component.exports